<label [for]="for" class="col-form-label">
    <strong>{{ label.name }}</strong>
    <ng-container *ngIf="subText">
        <small class="d-md-block"><em>{{ subText }}</em></small>
    </ng-container>
</label>